// ABOUTME: Smart wrapper for the Retarder entity — owns useRetarderEntity and reports state via context.
// ABOUTME: Renders skeleton/error/form so the page no longer branches per entity.
import React from 'react'

import {useRetarderEntity} from '../hooks/useRetarderEntity'
import {useEntityFormContext, useRegisterEntityForm} from '../context/EntityFormContext'
import {EntityContentEmpty} from './EntityContentEmpty'
import {EntityContentError} from './EntityContentError'
import {EntityContentSkeleton} from './EntityContentSkeleton'
import {RetarderForm} from './RetarderForm'

export const RetarderEntityForm: React.FC = () => {
  const ctx = useEntityFormContext()
  const {config, isLoading, error, isSaving, actions} = useRetarderEntity({
    countryId: ctx.countryId,
    businessLine: ctx.businessLine,
    scopeId: ctx.selectedScopeId,
    pendingScope: ctx.pendingScope,
    rootScopeId: ctx.rootScopeId,
  })

  useRegisterEntityForm(actions, isSaving)

  if (isLoading) return <EntityContentSkeleton />
  if (error) return <EntityContentError />
  if (!config) return <EntityContentEmpty />

  return (
    <RetarderForm
      key={ctx.formResetKey}
      config={config}
      isReadOnly={ctx.isReadOnly}
      onDirtyChange={ctx.onDirtyChange}
      onValidChange={ctx.onValidChange}
      onValuesChange={actions.handleValuesChange}
      options={ctx.retarderOptions}
    />
  )
}
